import React, { useCallback, useState } from 'react';

import GuestVideoPlayer from '../../components/GuestHomePageComponents/GuestVideoPlayer';
import '../Home/GuestHomePage.css';
import './FreeSegmentsPage.css';
import GuestHomeFeaturedSection from '../../components/GuestHomePageComponents/GuestHomeFeaturedSection';


function FreeSegmentsPage(props) {
  const { user } = props;
  const [selectedVideo, setSelectedVideo] = useState({});

  const setVideoToPlay = useCallback((video) => {
    setSelectedVideo(video);
  }, [setSelectedVideo]);

  return (
    <div className="free-segment-page" id="guest-page">
      <div className="featured-section-container container">
        <GuestHomeFeaturedSection
          selectedVideo={selectedVideo}
          setSelectedVideo={setVideoToPlay}
          type="past_clips"
        />
      </div>
      <div className="main-carousel-home guest-home-main guest-video-right">
        <GuestVideoPlayer selectedVideo={selectedVideo} user={user} />
      </div>
      <div className="featured-section-container container">
        <GuestHomeFeaturedSection type="recommended_clips" />
      </div>
    </div>
  );
}

export default React.memo(FreeSegmentsPage);
